module.exports = __webpack_public_path__ + "media/images/login/login_mid_l-78702d14e12a19ef9d20734cf9ff3a1a.gif";